"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitFloatingLink = void 0;
var _plateCommon = require("@udecode/plate-common");
var _plateLink = require("@udecode/plate-link");
/**
 * Insert link if url is valid. Text is url if empty. Close floating link. Focus
 * editor.
 */
var submitFloatingLink = function submitFloatingLink(editor) {
  var _transformInput;
  if (!editor.selection) return;
  var _ref = (0, _plateCommon.getPluginOptions)(editor, _plateLink.ELEMENT_LINK),
    forceSubmit = _ref.forceSubmit,
    transformInput = _ref.transformInput;
  var inputUrl = _plateLink.floatingLinkSelectors.url();
  var url = transformInput ? (_transformInput = transformInput(inputUrl)) !== null && _transformInput !== void 0 ? _transformInput : '' : inputUrl;
  if (!forceSubmit && !(0, _plateLink.validateUrl)(editor, url)) return;
  var text = _plateLink.floatingLinkSelectors.text();
  var target = _plateLink.floatingLinkSelectors.newTab() ? '_blank' : undefined;
  _plateLink.floatingLinkActions.hide();
  (0, _plateLink.upsertLink)(editor, {
    skipValidation: true,
    target: target,
    text: text,
    url: url
  });

  // FIXME: focusEditor is not working in the web-front build. It does not seem to be needed here though.
  // setTimeout(() => {
  // 	focusEditor(editor, editor.selection!);
  // }, 0);

  return true;
};
exports.submitFloatingLink = submitFloatingLink;